<template lang="pug">
    
    MDashboardWidget( title="Identified Tracking" )
     table( class="table-hover no-margins" )
        thead
        th
          th CMP Immediate
            th No CMP
              th CMP Allow All
                th Other
          
        tbody
          tr
            td FP cookie Identified
            td {{ fpCookie.cmpImmediate }} 
            td {{ fpCookie.noCmp }}
            td {{ fpCookie.cmpAllowall }}
            td {{ fpCookie.noCmp }}
          tr
            td Other
            td {{ other.cmpImmediate }}
            td {{ other.noCmp }}
            td {{ other.cmpAllowall }}
            td {{ other.cmpOther }}
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
          fpCookie: {
              cmpImmediate: '20(565)',
              noCmp: '50(923)',
              cmpAllowall: 20,
              cmpOther: '4(3)',
          },  
          other: {
              cmpImmediate: '12(60)',
              noCmp: '12(92)',
              cmpAllowall: 4,
              cmpOther: '4(4)',
          }
        }
    }
})
</script>